import React from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/client';

// This is needed for @eurostar/ui-components
import { EurostarLegacyThemeProvider } from '@eurostar/ui-components';

import { BrowserRouter as RouteProvider } from 'react-router-dom';

import IntlProvider from 'providers/IntlProvider';
import { ToastProvider } from 'components/ui/Toast';
import client from 'store/client';

const Provider = ({ children }) => (
  <ApolloProvider client={client}>
    <IntlProvider>
      <ToastProvider>
        <EurostarLegacyThemeProvider>
          <RouteProvider>{children}</RouteProvider>
        </EurostarLegacyThemeProvider>
      </ToastProvider>
    </IntlProvider>
  </ApolloProvider>
);

Provider.propTypes = {
  children: PropTypes.node
};

export default Provider;
